<template>
  <div class="footer" style="color: #ffffff; height: 100%; width: 100%">
    <div class="footer_router">
      <div class="footer_box">
        <img class="footer_router_img" :src="$t('layout.logo2')" alt="" />
      </div>
      <span
        class="footer_text"
        @click="
          clickrouter(
            roleName && roleName.includes(`GAME_DEVELOPER`)
              ? '/game_management'
              : '/app_management'
          )
        "
        >{{
          roleName && roleName.includes("GAME_DEVELOPER")
            ? $t("router.GameManagement")
            : $t("router.appManagement")
        }}
      </span>
      <span class="footer_xian">|</span>
      <span class="footer_text" @click="clickrouter('/Operational_data')">{{
        $t("router.operation")
      }}</span>
      <span class="footer_xian">|</span>
      <span class="footer_text" @click="clickrouter('/account_management')">{{
        $t("router.AccountManagement")
      }}</span>
      <span class="footer_xian">|</span>
      <span class="footer_text" @click="handleMenuClick">{{
        $t("router.DeveloperDocument")
      }}</span>
      <span class="footer_xian">|</span>
      <span class="footer_text" @click="clickrouter('/contact')">{{
        $t("router.contact")
      }}</span>
    </div>
    <div class="footer_ICP">
      {{ $t("footer.text") }}
    </div>
  </div>
</template>

<script>
import { BASE_HOST } from "../config/config";

export default {
  data() {
    return {
      roleName: localStorage.getItem("roleName"),
    };
  },
  methods: {
    handleMenuClick(e) {
      window.open(`${BASE_HOST}/tga-doc${this.$t("config.h5tgadoc")}`);
    },
    clickrouter(path) {
      var configlink = [
        "/login",
        "/info",
        "/register",
        "/agreement",
        "/forget",
      ];
      if (path == "/file") {
        return;
      }

      if (path == "/index" || path == "/contact") {
      } else {
        if (!localStorage.getItem("mp_accessToken")) {
          this.$message.info(this.$t("footer.to_login"));

          this.$router.push({
            path: "/login",
          });
          return;
        }
        if (configlink.includes(this.$route.path)) {
          this.$message.info(this.$t("footer.to_info"));
          this.$router.push({
            path: "/info",
          });

          return;
        }
      }
      if (this.$route.path == path) {
        return;
      }
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style>
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 18.7%;
}
.footer_text,
.footer_xian {
  color: #999999;
  cursor: pointer;
  font-size: 14px;
}
.footer_ICP {
  padding-top: 67px;
  color: #999999;
  font-size: 14px;
}
.footer_xian {
  margin: 0 14px;
}
.footer_router_img {
  width: 208px;
  height: 20px;
}
.footer_box {
  text-align: left;
  padding-top: 27px;
  padding-bottom: 27px;
}
</style>



// WEBPACK FOOTER //
// src/views/footer.vue